const searchConfig = {
  name: 'custom',
  listTitle: '自定义标签列表',
  searchMode: "group",
  columns: [
    {
      label: '标签分类名称',
      itemType: 'input',
      name: 'label',
      labelProps: {
        width: 90
      }
    },
    {
      label: '标签分类ID',
      itemType: 'input1',
      name: 'id',
      labelProps: {
        width: 90
      }
    },
  ]
}

const tableConfig = {
  rowSelectionType: 'radio',
  pagination: false,
  fieldControl: false,
  tableType: 'antd',
  scroll:{ y: 500},
  search: false,
  columns: [
    {
      title: '分类名称',
      dataIndex: 'label',
      key: 'label',
      width: 160,
    },
    {
      title: '分类ID',
      dataIndex: 'id',
      key: 'id',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: '#',
      render: 'actionRender',
      fixed: 'right',
      width: 200,
    },
  ],
  footer: [
    {
      label: '新增分类',
      type: 'primary',
      events: ['onClick:onAddTagType']
    }
  ]
}

const tagConfig = {
  pagination: false,
  rowSelection: false,
  fieldControl: false,
  search: false,
  scroll:{ y: 500},
  columns: [
    {
      title: '标签',
      dataIndex: 'label',
      key: 'label',
      width: 160,
    },
    {
      title: '',
      dataIndex: '#',
      render: 'actionRender',
      fixed: 'right',
      width: 160,
    },
  ],
  footer: [
    {
      label: '新增',
      itemType: 'custom',
      render: 'addTagRender',
      disabled: 'disabled',
      events: ['onClick:onAddTag']
    }
  ]
}

export default {searchConfig, tableConfig, tagConfig};